import React, { useState } from "react";
import styles from "./VendorPanel.module.css";

export default function VendorPanel({ vendors, loadingVendors, onChange }) {
  const [list, setList] = useState([
    { name: "", id: null, show: false, highlight: -1 },
    { name: "", id: null, show: false, highlight: -1 },
    { name: "", id: null, show: false, highlight: -1 },
    { name: "", id: null, show: false, highlight: -1 },
    { name: "", id: null, show: false, highlight: -1 }
  ]);

  const handleChange = (idx, value) => {
    const newList = [...list];
    newList[idx].name = value;
    newList[idx].id = null;
    newList[idx].show = true;
    newList[idx].highlight = 0;
    setList(newList);
    onChange && onChange(newList);
  };

  const handleKeyDown = (idx, e) => {
    const filtered = vendors.filter(vv =>
      vv.name.toLowerCase().includes(list[idx].name.toLowerCase())
    );

    if (!list[idx].show || !filtered.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      const newList = [...list];
      newList[idx].highlight =
        newList[idx].highlight < filtered.length - 1
          ? newList[idx].highlight + 1
          : 0;
      setList(newList);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const newList = [...list];
      newList[idx].highlight =
        newList[idx].highlight > 0
          ? newList[idx].highlight - 1
          : filtered.length - 1;
      setList(newList);
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (list[idx].highlight >= 0) {
        const vv = filtered[list[idx].highlight];
        selectVendor(idx, vv);
      }
    } else if (e.key === "Escape") {
      const newList = [...list];
      newList[idx].show = false;
      setList(newList);
    }
  };

  const selectVendor = (idx, vendor) => {
    const newList = [...list];
    newList[idx].name = vendor.name;
    newList[idx].id = vendor.id;
    newList[idx].show = false;
    setList(newList);
    onChange && onChange(newList);
  };

  return (
    <div className={styles.sidePane}>
      <div className={styles.scrollWrap}>
        <table className={styles.vendorTable}>
          <thead>
            <tr>
              <th>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: 6 }}>
                  <span>거래처 1</span>
                  {/* ✅ 새 창으로 거래처 관리 페이지(/etc/vendors)를 열어 즉시 등록 —
                      크기를 등록 폼이 보이는 정도로 지정. 등록 후 이 작성 페이지로
                      돌아오면(창 포커스 복귀) 아래 focus 리스너가 거래처 목록을
                      자동 재조회해 방금 등록한 거래처가 검색에 바로 잡힌다. */}
                  <button
                    type="button"
                    onClick={() => window.open("/etc/vendors", "vendorRegisterPopup", "width=1000,height=800")}
                    title="새 창에서 거래처 등록"
                    style={{
                      height: 18, padding: "0 6px", fontSize: 10, lineHeight: "16px",
                      whiteSpace: "nowrap", cursor: "pointer", border: "1px solid #ccc",
                      borderRadius: 4, background: "#fff", color: "#374151", fontWeight: 400,
                    }}
                  >
                    거래처 DB 입력
                  </button>
                </div>
              </th>
              <th>거래처 2</th>
              <th>거래처 3</th>
              <th>거래처 4</th>
              <th>거래처 5</th>
            </tr>
          </thead>
          <tbody>
            <tr className={styles.inputRow}>
              {list.map((v, idx) => {
                const filtered = vendors.filter(vv =>
                  vv.name.toLowerCase().includes(v.name.toLowerCase())
                );

                return (
                  <td key={idx} style={{ position: "relative", overflow: "visible" }}>

                    <input
                      value={v.name}
                      onChange={(e) => handleChange(idx, e.target.value)}
                      onFocus={() => {
                        const newList = [...list];
                        newList[idx].show = true;
                        setList(newList);
                      }}
                      onKeyDown={(e) => handleKeyDown(idx, e)}
                      placeholder={`거래처 ${idx + 1}`}
                    />
                    
                    {v.show && (
                      <div className={styles.vendorDropdown}>
                        {loadingVendors && <div>불러오는 중...</div>}
                        {filtered.length ? (
                          filtered.map((vv, i) => (
                            <div
                              key={vv.id}
                              className={`${styles.vendorItem} ${i === v.highlight ? styles.activeItem : ""}`}
                              onClick={() => selectVendor(idx, vv)}
                            >
                              {vv.name}
                            </div>
                          ))
                        ) : (
                          <div className={styles.vendorItem}>일치하는 거래처 없음</div>
                        )}
                      </div>
                    )}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}